import React, { useState } from "react";
import "./Section_12.css";
import SurveyForm from "../surveyform2/survey_form_2"; // adjust import path if needed
import { DynamicIcon } from 'lucide-react/dynamic';

function Section12({ sectionConfig, onOpenSurvey }) {
  const [showForm, setShowForm] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState("");
const getLucideIcon = (iconName, size =35) => {
             if (!iconName) return null;
             return <DynamicIcon name={iconName} size={size} />;
           };

  if (!sectionConfig || !sectionConfig.items) return null;

  const handleApplyClick = (positionTitle) => {
    setSelectedPosition(positionTitle);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedPosition("");
  };

  return (
    <section className="section-12">
      <h1 className="section-title">{sectionConfig.title}</h1>
      <h2 className="section-title2">{sectionConfig.subtitle}</h2>

      <div className="jobs-grid">
        {sectionConfig.items.map((item, idx) => (
          <div key={idx} className="job-card">
            {/* Top row: Icon + Title & Job Info */}
            <div className="job-top-row">
              <div className="job-icon">{getLucideIcon(item.icon)|| "💼"}</div>
              <div className="job-info">
                <div className="job-title">{item.title}</div>
                <div className="job-meta">
                  {item.jobtype} • {item.address}
                </div>
              </div>
            </div>

            {/* Description */}
            <p className="job-description">{item.description}</p>

            {/* Chips */}
            <div className="job-chips">
              {item.chips.map((chip, i) => (
                <span key={i} className="job-chip">
                  {chip}
                </span>
              ))}
            </div>

            {/* Apply Button */}
            <div className="job-apply">
              <button
                className="btn apply-btn"
                onClick={() => handleApplyClick(item)}
              >
                Apply
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Dialog */}
      {showForm && (
  <div className="modal-overlay">
    <div className="modal-content">
      <button className="close-btn" onClick={handleCloseForm}>✖</button>
      <SurveyForm
        path="apply-job"
        defaultPosition={selectedPosition}
      />
    </div>
  </div>
)}
    </section>
  );
}

export default Section12;
